import axios from "axios"
import { BlockType } from "shared/types/science35Types"

export type OrganizationType = "school"

export type RequestQuoteEmailProps = {
    organizationName: string,
    contactName: string,
    contactEmail: string,
    organizationType: OrganizationType,
    state: string,
    productType?: BlockType
    studentCount: string,
    moreDetails: string,
    username?: string,
}

export async function requestQuoteEmail(props: RequestQuoteEmailProps) {
    const response = await axios.post("/api/request-quote", props)
    return response.data
}

const contactUs = {
    requestQuoteEmail,
}

export default contactUs
